<template>
    <div class="carbis-footer">
        <div class="info-block">
            <a target="_blank" href="https://www.carbis.ru">ГК "Карбис"</a>
        </div>
        <div class="info-block">
            <a target="_blank" href="https://wiki.carbis.ru/doku.php?id=external:minidlv2:main">
            Powered by Carbis mini-Delivery
            </a>
        </div>
        <div class="info-block">
            <a target="_blank" href="https://dostavka.carbis.ru">Хочу себе!</a>
        </div>
    </div>    
</template>

<script>
export default {
    
}
</script>
